import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

import Text from 'components/Text';
import Stack from 'components/Stack';
import { ImageShape } from 'utils/props';

import { color } from 'styles/utils';

const StyledPostCard = styled.div`
  background-color: ${color('white')};
  border-radius: 0.25rem;
  box-shadow: 0px 2px 10px 0px #0000000d;
  width: 20rem;

  img {
    border-radius: 0.25rem 0.25rem 0 0;
  }

  a {
    text-decoration: none;
  }
`;

const InnerContent = styled(Stack)`
  padding: 1rem;
`;

export default function PostCard({ title, subTitle, image, link, ...rest }) {
  return (
    <StyledPostCard {...rest}>
      <Link to={link}>
        {image && (
          <GatsbyImage
            image={getImage(image.image?.asset || image)}
            alt={image?.alt || title}
          />
        )}
        <InnerContent gap="1rem">
          <Text variant="smallestP" color="teal">
            {subTitle}
          </Text>
          <Text as="h3" variant="f3.resources" color="mediumTeal">
            {title}
          </Text>
        </InnerContent>
      </Link>
    </StyledPostCard>
  );
}

PostCard.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  image: ImageShape.isRequired,
  link: PropTypes.string.isRequired,
};
